"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseActivationWorkflowButton = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../../common/js/components/GlobalModal");
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const LicenseState_1 = require("../../../common/js/enums/LicenseState");
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const string_1 = require("../../../common/js/helper/string");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const ProductType_1 = __importDefault(require("../../enums/ProductType"));
const useLicenseState_1 = require("../../hooks/useLicenseState");
const LicenseConsentModal_1 = require("../LicenseConsentModal");
const GenericLicenseActivationWorkflowButton_1 = require("./GenericLicenseActivationWorkflowButton");
const MindActivationWorkflowButton_1 = require("./MindActivationWorkflowButton");
const WebPortalActivationWorkflowButton_1 = require("./WebPortalActivationWorkflowButton");
exports.LicenseActivationWorkflowButton = (0, mobx_react_1.observer)(({ license }) => {
    const { state, isFetching } = (0, useLicenseState_1.useLicenseState)(license);
    const consentButtonEnabled = state === LicenseState_1.LicenseState.Inactive && !AuthorizationStore_1.default.isDelegatedCustomer;
    const renderActivationWorkflowButton = (0, react_1.useCallback)((productType, activationLicense) => {
        switch (productType) {
            case ProductType_1.default.MINDCAD:
            case ProductType_1.default.MINDCUT:
            case ProductType_1.default.MINDGEST:
            case ProductType_1.default.MINDGUEST:
                return react_1.default.createElement(MindActivationWorkflowButton_1.MindActivationWorkflowButton, { license: activationLicense });
            case ProductType_1.default.PRIMECENTER:
            case ProductType_1.default.ZUND_CONNECT:
                return react_1.default.createElement(GenericLicenseActivationWorkflowButton_1.GenericLicenseActivationWorkflowButton, { license: activationLicense });
            case ProductType_1.default.ZUND_CUT_CENTER:
            case ProductType_1.default.ZUND_DESIGN_CENTER:
            case ProductType_1.default.ZUND_PRECUT_CENTER:
                return react_1.default.createElement(WebPortalActivationWorkflowButton_1.WebPortalActivationWorkflowButton, { license: activationLicense });
        }
        return null;
    }, []);
    return (react_1.default.createElement("div", { className: "d-flex flex-row" },
        react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('myassets.software.btn.license_consent.title'), onClick: () => {
                (0, GlobalModal_1.showModal)({
                    component: LicenseConsentModal_1.LicenseConsentModal,
                    props: { license },
                });
            }, loading: isFetching, disabled: !consentButtonEnabled || isFetching, icon: Zupicons_1.default.fileContracts }),
        renderActivationWorkflowButton((0, string_1.slugifyKey)(license.productType), license)));
});
